import { getContext } from "svelte";
import { setContext } from "svelte";
export let updateMachineStateSymbol = Symbol('updateMachineProgramState');
export function setUpdateMachineState(updateMachineProgramState) {
    return setContext(updateMachineStateSymbol, updateMachineProgramState);
}
export function getUpdateMachineState() {
    return getContext(updateMachineStateSymbol);
}
